
import React, { Component } from 'react';

const focusabledElements = 'input, textarea, .ant-select-selection, .ant-radio-button-wrapper';

export default function withAutoFocusForm(WrappedComponent) {
    return class extends Component {
        componentDidMount() {
            setTimeout(() => {
                if (!this.container) {
                    return;
                }

                const focusable = this.container.querySelector(focusabledElements);

                focusable && focusable.focus();
            });
        }

        render() {
            return (
                <div ref={node => this.container = node}>
                    <WrappedComponent {...this.props} />
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/hocs/withAutoFocusForm.js